import { useEffect, useState } from "react";
import SupportServices3D from "../components/SupportServices3D";
import EmergencyCare from "components/EmergencyCare";

const cardGradient =
    "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)"

function Services() {
    const slides = [
        {
            title: "24×7 Emergency Services",
            desc: "Immediate medical care for critical and life-threatening conditions.",
        },
        {
            title: "Advanced Diagnostic Services",
            desc: "Accurate diagnosis with modern medical equipment.",
        },
        {
            title: "Specialized Medical Care",
            desc: "Expert doctors across multiple specialties.",
        },
    ];

    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % slides.length);
        }, 3500);

        return () => clearInterval(timer);
    }, [slides.length]);


    return (
        /* ===== SAME AS HOME PAGE ===== */
        <div className="min-h-screen bg-transparent">

            {/* ================= SUPPORT SERVICES (3D SLIDER) ================= */}
            <SupportServices3D />


            {/* ================= ADVANCED CARE & FACILITIES ================= */}
            <section className="py-8 md:py-10">
                <div className="max-w-7xl mx-auto px-4">

                    {/* 🔵 MAIN BACKGROUND BOX */}
                    <div
                        className="rounded-3xl shadow-2xl p-8 md:p-10"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        {/* Heading */}
                        <h2 className="text-3xl font-semibold text-center text-white mb-8">
                            Advanced Care & Facilities
                        </h2>

                        {/* Cards Grid */}
                        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
                            {[
                                {
                                    title: "ICU & Critical Care",
                                    desc: "Fully equipped ICU with advanced life support and continuous patient monitoring.",
                                    img: "/images/Services/Advance/ICU.jpg",
                                },
                                {
                                    title: "24×7 Emergency Services",
                                    desc: "Round-the-clock emergency and trauma care with rapid response teams.",
                                    img: "/images/Services/Advance/Emergency.jpg",
                                },
                                {
                                    title: "Modern Diagnostics",
                                    desc: "Advanced pathology, ECG, imaging, and ultrasound diagnostic services.",
                                    img: "/images/Services/Advance/ECG.jpg",
                                },
                                {
                                    title: "Advanced Operation Theatre (OT)",
                                    desc: "State-of-the-art modular OT with sterile environment and modern surgical equipment.",
                                    img: "/images/Services/Advance/OT.jpg",
                                },
                            ].map((item, i) => (
                                <div
                                    key={i}
                                    className="bg-white rounded-2xl shadow-lg overflow-hidden text-gray-800 hover:shadow-xl transition"
                                >
                                    {/* IMAGE */}
                                    <div className="w-full h-56 sm:h-64 md:h-72 overflow-hidden">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className="w-full h-full block object-cover"
                                        />
                                    </div>

                                    {/* CONTENT */}
                                    <div className="p-6 text-center">
                                        <h3 className="text-lg font-semibold text-blue-600 mb-2">
                                            {item.title}
                                        </h3>
                                        <p className="text-sm leading-relaxed">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= CAROUSEL ================= */}
            <section className="py-8 md:py-12">
                <div className="max-w-4xl mx-auto bg-white text-gray-800 rounded-2xl shadow-xl p-8 md:p-10 text-center">
                    <h2 className="text-2xl font-semibold text-blue-600 mb-4">
                        {slides[current].title}
                    </h2>

                    <p className="text-lg text-gray-600">
                        {slides[current].desc}
                    </p>

                    <div className="flex justify-center gap-2 mt-5">
                        {slides.map((_, i) => (
                            <span
                                key={i}
                                onClick={() => setCurrent(i)}
                                className={`h-3 w-3 rounded-full cursor-pointer ${i === current ? "bg-blue-600" : "bg-gray-300"
                                    }`}
                            ></span>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= DIAGNOSTIC SERVICES ================= */}
            <section className="py-8 md:py-12">
                <div className="max-w-7xl mx-auto px-4">

                    {/* 🔵 MAIN BACKGROUND BOX */}
                    <div
                        className="rounded-3xl shadow-2xl p-8 md:p-10"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                        }}
                    >
                        {/* Heading */}
                        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8">
                            Diagnostic Services
                        </h2>

                        {/* Cards Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                            {[
                                ["Pathology Laboratory", "Accurate lab testing & reports.", "pathology.jpg"],
                                ["Digital X-Ray", "High resolution digital imaging.", "digital-xray.jpg"],
                                ["ECG & 2D Echo", "Advanced cardiac diagnostics.", "ecg.jpg"],
                                ["Blood Checkup", "Complete blood investigations.", "blood.jpg"],
                                ["Ultrasound", "Safe & accurate imaging.", "ultrasound.jpg"],
                                ["Diabetes & Thyroid", "Hormone & sugar testing.", "diabetes.jpg"],
                                ["Pre-operative Tests", "Surgery readiness tests.", "preoperative.jpg"],
                                ["Health Check-up", "Preventive diagnostics.", "health.jpg"],
                            ].map(([title, desc, img], i) => (
                                <div
                                    key={i}
                                    className="rounded-xl overflow-hidden transition hover:shadow-xl bg-white"
                                    style={{
                                        boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
                                        border: "1px solid rgba(255,255,255,0.6)",
                                    }}
                                >
                                    <img
                                        src={`/diagnostic/${img}`}
                                        alt={title}
                                        className="w-full h-44 object-cover"
                                        loading="lazy"
                                    />

                                    <div className="p-5 text-center">
                                        <h4 className="text-base font-bold text-[#0b3c78]">
                                            {title}
                                        </h4>
                                        <p className="text-sm text-[#1f2937] mt-2 leading-relaxed">
                                            {desc}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            {/* ================= CLEANNESS SERVICES ================= */}
            <section className="py-8 md:py-12">
                <div className="max-w-7xl mx-auto px-4">

                    {/* 🔵 MAIN GRADIENT BOX */}
                    <div
                        className="rounded-3xl shadow-2xl p-8 md:p-10"
                        style={{
                            background:
                                "linear-gradient(135deg, #0b4fb3, #2f80ed, #7cc7f5, #e7b7f3)",
                        }}
                    >

                        {/* HEADING */}
                        <div className="text-center mb-10">
                            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
                                Cleanliness & Safety
                            </h2>

                            {/* TEXT WHITE BOX (FOR VISIBILITY) */}
                            <div className="inline-block bg-white/95 backdrop-blur rounded-xl px-6 py-4 shadow-md max-w-3xl">
                                <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                                    Gavli Hospital में स्वच्छता और सुरक्षा को सर्वोच्च प्राथमिकता दी जाती है,
                                    जिससे मरीजों को सुरक्षित एवं स्वच्छ वातावरण मिलता है।
                                </p>
                            </div>
                        </div>

                        {/* CARDS GRID */}
                        <div className="grid md:grid-cols-2 gap-8">

                            {/* MEN BOX */}
                            <div className="bg-white rounded-2xl shadow-xl p-6 text-center">
                                <img
                                    src="/images/Home/men-clean.jpg"
                                    alt="Men Cleaning Staff"
                                    className="rounded-xl w-full h-56 md:h-64 object-cover mb-4"
                                />
                                <h3 className="text-lg md:text-xl font-semibold text-[#0b3c78] mb-2">
                                    Men Cleaning Staff
                                </h3>
                                <p className="text-gray-600 text-sm leading-relaxed">
                                    कॉरिडोर, waiting area और common zones की
                                    नियमित सफाई प्रशिक्षित पुरुष स्टाफ द्वारा की जाती है।
                                </p>
                            </div>

                            {/* WOMEN BOX */}
                            <div className="bg-white rounded-2xl shadow-xl p-6 text-center">
                                <img
                                    src="/images/Home/women-clean.jpg"
                                    alt="Women Cleaning Staff"
                                    className="rounded-xl w-full h-56 md:h-64 object-cover mb-4"
                                />
                                <h3 className="text-lg md:text-xl font-semibold text-[#0b3c78] mb-2">
                                    Women Cleaning Staff
                                </h3>
                                <p className="text-gray-600 text-sm leading-relaxed">
                                    वार्ड, लिफ्ट और patient zones में
                                    महिला स्टाफ द्वारा विशेष स्वच्छता रखी जाती है।
                                </p>
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* ================= CTA ================= */}
            <section className="py-20">
                <div
                    className="max-w-4xl mx-auto rounded-2xl shadow-xl p-12 text-center text-white"
                    style={{
                        background:
                            "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                    }}
                >
                    <h2 className="text-2xl font-bold mb-3">
                        Need Medical Assistance?
                    </h2>
                    <p className="mb-6">
                        Our team is available 24×7 for your care
                    </p>
                    <a
                        href="tel:108"
                        className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition"
                    >
                        Call Emergency 108
                    </a>
                </div>
            </section>

        </div>
    );
}

export default Services;
